import withStore, { TLoadingAwarePresenter, TPresentable } from "../withStore";
import Application from "../../Application";
import { ILanguage } from "../../model/language/Language";
import ShowErrorMessageInteractor from "../../interactor/notifications/ShowErrorMessageInteractor";
import ChangeLanguageInteractor from "../../interactor/settings/ChangeLanguageInteractor";
import ShowSuccessMessageInteractor from "../../interactor/notifications/ShowSuccessMessageInteractor";
import { UserPreferences } from "../../common/Constants";

export interface TSettingsPresenter extends TLoadingAwarePresenter {
  languages: ILanguage[];
  currentLanguageCode: number;
  isPortalActive: boolean;
}
export interface ISettingsPresenter extends TSettingsPresenter, TPresentable {
  changeLanguage(languageCode: number): void;
  setInitialData(
    languages: ILanguage[],
    currentLanguageCode: number,
    isPortalActive: boolean
  ): void;
}

const defaultState: TSettingsPresenter = {
  languages: [],
  currentLanguageCode: UserPreferences.DEFAULT_LANGUAGE,
  isPortalActive: true
};

const SettingsPresenter = withStore<ISettingsPresenter, TSettingsPresenter>(
  ({ application, store, loader, translate }): ISettingsPresenter => {
    const _store = store;
    const _application: Application = application;
    const state = _store.getState<TSettingsPresenter>();

    const setInitialData = (
      languages: ILanguage[],
      currentLanguageCode: number,
      isPortalActive: boolean
    ) => {
      _store.update({
        languages,
        currentLanguageCode,
        isPortalActive
      });
    };

    const changeLanguage = async (languageCode: number) => {
      try {
        const { isPortalActive } = _store.getState<ISettingsPresenter>();

        await _application.container
          .resolve<ChangeLanguageInteractor>("changeLanguage")
          .execute(languageCode, isPortalActive);
        _store.update({ currentLanguageCode: languageCode });
        _application.changeSystemLanguage(languageCode);
        window.location.reload();
        _application.container
          .resolve<ShowSuccessMessageInteractor>("showSuccessMessage")
          .execute(translate("change_language_form.messages.change_success"));
      } catch (error) {
        _application.container
          .resolve<ShowErrorMessageInteractor>("showErrorMessage")
          .execute((error as any).message);
      }
    };

    return {
      ...state,
      store: _store,
      loader,
      application: _application,
      translate,
      setInitialData,
      changeLanguage
    };
  },
  defaultState
);

export default SettingsPresenter;
